module.exports = __webpack_public_path__ + "no-data-863af5e11a424d2a51c7f50c765cef17.png";